import { Component, OnInit } from '@angular/core';
import { PosterRequest } from '../poster-request';
import { Result } from '../result';
import { Router } from '@angular/router';
import { JwtService } from '../../jwt/jwt.service';
import { environment } from '../../../environments/environment';
import { ExtraService } from '../../common/api/extra.service';

@Component({
    selector : 'app-poster',
    templateUrl : './poster-make.component.html',
    styleUrls : ['./poster-make.component.css'],
})
export class PosterMakeComponent implements OnInit {
    upload = false;
    imgPath = 'image/org_default.jpg';
    overlay = 'image/overlay.png';
    introduceImage = '';
    saleImage = 'image/sale.png';
    fontStyle = 'Noto Sans KR, sans-serif';
    poster: PosterRequest = {'title': '', 'introduce': '0', 'font': 'noto', 'croppedImage': '', 'sale': false, 'username': ''};
    imageNo = 0;
    initialFont = 'noto';

    constructor(private router: Router, public jwtService: JwtService
      , private extraService: ExtraService) {}


    ngOnInit() {}


    fileUpload() {
         document.getElementById('imageFile').click();
    }

    imageChange($event) {
      this.readUrl($event.target);
    }

    readUrl(input) {
        const file: File = input.files[0];
        const reader = new FileReader();

        reader.onload = function (e) {
          const src = reader.result;
          $('#image').cropper('replace', src);
        };

        this.upload = true;
        this.imageNo = input;

        const src = environment.imageUrl + '/images/' + input + '/view';

       $('#image').cropper({
             viewMode: 3,
             dragMode: 'move',
             autoCropArea: 1,
             modal: false,
             guides: true,
             cropBoxMovable: false,
             cropBoxResizable: false,
             background : false,
             minCanvasWidth : 350,
             minCanvasHeight : 350,
             minContainerWidth : 350,
             minContainerHeight : 350,
             minCropBoxWidth : 350,
             minCropBoxHeight : 350
        });

        reader.readAsDataURL(file);

    }

    zoom(ratio) {
        if (this.upload) {
            $('#image').cropper('zoom', ratio);
        } else {
            alert('이미지를 등록해주세요.');
        }
    }

    rotate() {
        if (this.upload) {
            $('#image').cropper('rotate', 90);
        } else {
            alert('이미지를 등록해주세요.');
        }
    }

    titleChange() {
        if (!this.upload) {
            alert('이미지를 등록해주세요.');
            this.poster.title = '';
        }
    }

    introduceChange() {
        if (this.upload) {
            this.introduceImage = 'image/' + this.poster.introduce + '.png';
        } else {
            alert('이미지를 등록해주세요.');
            this.poster.introduce = '0';
        }
    }

    fontChange(event) {
        if (event === 'noto') {
            this.fontStyle = 'Noto Sans KR, sans-serif';
            this.poster.font = 'noto';
        } else if (event === 'jeju') {
            this.fontStyle = 'Jeju Hallasan, sans-serif';
            this.poster.font = 'jeju';
        } else if (event === 'hanna') {
            this.fontStyle = 'Hanna, sans-serif';
            this.poster.font = 'hanna';
        } else if (event === 'bon') {
            this.fontStyle = 'source-han-serif-korean, serif';
            this.poster.font = 'bon';
        }

    }

    saleChange() {
        if (!this.upload) {
            this.poster.sale = false;
            alert('이미지를 등록해주세요.');
        }
    }

    /**
     * 세일 체인지
     */
    saleChangeActual(event) {
        if (!this.upload) {
            this.poster.sale = false;
            alert('이미지를 등록해주세요.');
        }
    }

    /**
     * 포스터 생성
     */
    postImage() {

        if (this.upload) {
          const formData = new FormData();
          const router = this.router;
          const base64 = $('#image').cropper('getCroppedCanvas', {width: 350, height: 350}).toDataURL();
          const byteString  = atob(base64.split(',')[1]);
          const mimeString = base64.split(',')[0].split(':')[1].split(';')[0];
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);

          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }

          const blob = new Blob([ab], {type: mimeString});

          formData.append('file', blob);
          formData.append('title', this.poster.title);
          if (this.poster.introduce !== '0') {
            formData.append('descriptionType', this.poster.introduce);
          }
          formData.append('sale', String(this.poster.sale));
          formData.append('fontType', this.poster.font);
          this.extraService.makeProductImage(formData)
            .subscribe(response => {
              alert('등록되었습니다.');
              router.navigate(['poster/list']);
            }
           );
        }
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/poster/make/poster-make.component.ts